import { FC } from "react";

import { Button } from "@mantine/core";
import { modals } from "@mantine/modals";

import { Template } from "../../models/Template.ts";
import classes from "../../styles/components/modals/CreateMailModal.module.scss";
import { TemplatedMailForm } from "../forms/TemplatedMailForm.tsx";

interface TemplatedMailFormComponentProps {
  onClose: () => void;
  template: Template;
}

const TemplatedMailFormComponent: FC<TemplatedMailFormComponentProps> = ({ onClose, template }) => {
  return (
    <>
      <TemplatedMailForm
        body={template.body}
        code={template.code}
        id={template.id}
        subject={template.subject}
        variables={template.variables}
      />
      <Button className={classes.button} onClick={onClose} variant="default">
        Cancel
      </Button>
    </>
  );
};

export const TemplatedMailModal = (template: Template) => {
  return (
    <Button
      className={"secondary-button"}
      onClick={() => {
        modals.open({
          title: <h2 style={{ fontWeight: "bold" }}>Test {template.code}</h2>,
          size: "xl",
          children: <TemplatedMailFormComponent onClose={modals.closeAll} template={template} />
        });
      }}
    >
      Test
    </Button>
  );
};
